import { createReducer, createActions } from 'reduxsauce'

const INITIAL_STATE = {
  loading: false,
  changeDashboardPass: false,
  changeMailboxPass: false,
  error: null
}

const { Types, Creators } = createActions(
  {
    refreshPasswordRequirementsRequest: [],
    refreshPasswordRequirementsSuccess: ['changeDashboardPass', 'changeMailboxPass'],
    refreshPasswordRequirementsFailure: ['error'],
    clearDashboardPassRequirement: [],
    clearMailboxPassRequirement: []
  },
  { prefix: 'AUDIT_' }
)

const refreshPasswordRequirementsRequest = (state) => ({
  ...state,
  loading: true,
  error: null
})

const refreshPasswordRequirementsSuccess = (state, { changeDashboardPass, changeMailboxPass }) => ({
  ...state,
  loading: false,
  changeDashboardPass,
  changeMailboxPass,
  error: null
})

const refreshPasswordRequirementsFailure = (state, { error }) => ({
  ...state,
  loading: false,
  error
})

const clearDashboardPassRequirement = (state) => ({
  ...state,
  changeDashboardPass: false
})

const clearMailboxPassRequirement = (state) => ({
  ...state,
  changeMailboxPass: false
})

const HANDLERS = {
  [Types.REFRESH_PASSWORD_REQUIREMENTS_REQUEST]: refreshPasswordRequirementsRequest,
  [Types.REFRESH_PASSWORD_REQUIREMENTS_SUCCESS]: refreshPasswordRequirementsSuccess,
  [Types.REFRESH_PASSWORD_REQUIREMENTS_FAILURE]: refreshPasswordRequirementsFailure,
  [Types.CLEAR_DASHBOARD_PASS_REQUIREMENT]: clearDashboardPassRequirement,
  [Types.CLEAR_MAILBOX_PASS_REQUIREMENT]: clearMailboxPassRequirement
}

export const AuditActionTypes = Types
export const AuditActionCreators = Creators

export default createReducer(INITIAL_STATE, HANDLERS)
